import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  Auth,
  browserLocalPersistence,
  indexedDBLocalPersistence,
  initializeAuth,
  onAuthStateChanged,
  provideAuth,
} from '@angular/fire/auth';

import { routes } from './app.routes';
import { TokenInterceptor } from '@core/auth/interceptors/token.interceptor';
import { environment } from '@environments/environment';

function waitForAuth(auth: Auth): Promise<void> {
  return new Promise<void>((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, () => {
      unsubscribe();
      resolve();
    });
  });
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([TokenInterceptor])),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() =>
      initializeAuth(getApp(), {
        persistence: [indexedDBLocalPersistence, browserLocalPersistence],
      }),
    ),
    {
      provide: 'waitForAuth',
      useFactory: (auth: Auth) => waitForAuth(auth),
      deps: [Auth],
    },
  ],
};
